import { ElementType, PropsWithChildren, ComponentPropsWithoutRef, Ref } from 'react';
import { css, cx } from '@linaria/atomic';

const contentPanelBodyComponentStyle1 = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
`;

type ElementTypePartial = Extract<ElementType, 'div' | 'section' | 'article'>;

type ContentPanelBodyProps<C> = {
  as?: C;
  containerRef?: Ref<HTMLDivElement>;
};

type Props<C extends ElementTypePartial> = PropsWithChildren<ContentPanelBodyProps<C>> &
  Omit<ComponentPropsWithoutRef<C>, keyof ContentPanelBodyProps<C>>;

export const ContentPanelBody = <C extends ElementTypePartial = 'div'>({
  children,
  as,
  containerRef,
  ...rest
}: Props<C>) => {
  const Component = as || 'div';

  return (
    <Component ref={containerRef} {...rest} className={cx(contentPanelBodyComponentStyle1, rest.className)}>
      {children}
    </Component>
  );
};
